module.exports = __webpack_public_path__ + "static/media/primary white 400px.cb48ce22.png";